import { render } from "./AiPortrait.vue?vue&type=template&id=252e7e78&scoped=true"
import script from "./AiPortrait.vue?vue&type=script&lang=js"
export * from "./AiPortrait.vue?vue&type=script&lang=js"

import "./AiPortrait.vue?vue&type=style&index=0&id=252e7e78&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252e7e78"]])

export default __exports__